angular.module('charts')
  .directive("badge", function() {
    return {
      restrict: "A",
      scope: {
        badgedata: '=',
      },
      transclude: true,
      replace: false,
      require: "^item-carousel",
      templateUrl: '/resources/charts/partials/badge.html',
      controller: ['$scope', '$element', '$rootScope', function($scope, $element, $rootScope) {
        var self = this;
        $scope.selectedID = 0;
        $scope.sections = $scope.badgedata.sections;

        $scope.sections.forEach(function(section) {
          section.status = (section.percent < 50 ? 'warn' : '');
        });

        $scope.click = function(id) {
          $scope.selectedID = id;
          $scope.$emit('badgeClick', id);
        };

        $($element[0]).data('label', ($scope.badgedata.label ? $scope.badgedata.label : ''));
        if ($scope.$parent.$last) {
          $scope.$emit('carouselReload');
        }
      }]
    };
  });
